import { render, staticRenderFns } from "./ImagPreview.vue?vue&type=template&id=7108324f&scoped=true&"
import script from "./ImagPreview.vue?vue&type=script&lang=js&"
export * from "./ImagPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagPreview.vue?vue&type=style&index=0&id=7108324f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108324f",
  null
  
)

export default component.exports